// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {forOwn, get} from 'lodash';

// Components
import Error from '../core/error';
import Loading from '../core/loading';
import RecordDetails from '../core/record-details';
import ServicesRefreshPanelAction from './services-refresh-panel-action';

// Configs
import servicesConfig from '../../../config/services-config';

export default class SearchRecordDetails extends Component {
    getClass() {
        const {className} = this.props;

        return classnames(
            {
                'search-record-details': true,
            },
            className
        );
    }

    hasSearchData() {
        const {routerParams, searchData, servicesDataKey} = this.props;
        const routerKeys = get(servicesConfig, [servicesDataKey, 'routerKeys']);
        let hasSearchData = searchData.length;

        if (hasSearchData && routerParams && routerKeys) {
            let hasRouterKey = false;

            forOwn(routerKeys, ({routerKey}) => {
                if (routerParams[routerKey]) {
                    hasRouterKey = true;

                    return false;
                }
            });

            hasSearchData = hasRouterKey;
        }

        return hasSearchData;
    }

    renderNoRecord() {
        const {fetching} = this.props;

        return !fetching ? <Error className="search-record-details--message" error="Choose a record." /> : null;
    }

    renderRecordDetails() {
        return this.hasSearchData() ? <RecordDetails {...this.props} /> : this.renderNoRecord();
    }

    render() {
        const {fetching, error} = this.props;

        return (
            <div className={this.getClass()}>
                <ServicesRefreshPanelAction />
                <Error error={error} />
                {this.renderRecordDetails()}
                <Loading loading={fetching} />
            </div>
        );
    }
}

SearchRecordDetails.propTypes = {
    blacklistKeys: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
    detailsConfig: PropTypes.object,
    error: PropTypes.string,
    fetching: PropTypes.bool,
    keyOrder: PropTypes.string,
    routerParams: PropTypes.object.isRequired,
    searchData: PropTypes.array.isRequired,
    servicesDataKey: PropTypes.string.isRequired,
    whitelistKeys: PropTypes.arrayOf(PropTypes.string),
};
